import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DefaultIcon, EnumSelect } from '@summit/core';
import { SummitIdObject } from '@summit/models';
import { CrudCacheParameters } from '@summit/services';
import { FloatLabel } from 'primeng/floatlabel';
import { MultiSelect } from 'primeng/multiselect';
import { Observable } from 'rxjs';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input';

@Component({
  selector: 's-form-input-multi-select',
  templateUrl: './s-form-input-multi-select.component.html',
  styleUrls: ['./s-form-input-multi-select.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, SFormErrorInputComponent, FormsModule, FloatLabel, MultiSelect, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SFormInputMultiSelectComponent<T extends SummitIdObject, U extends SummitIdObject>
  extends SummitControl<T>
  implements OnInit
{
  @Input() items$: Observable<U[] | EnumSelect[]>;
  // @Input() unfilteredItems$?: Observable<U[]> = null;
  @Input() keyProperty: keyof U & string;
  @Input() displayProperty: keyof U & string;
  @Input() disabledProperty: keyof U & boolean;
  @Input() group: boolean;
  @Input() groupIcon: string;
  @Input() cacheParameters: Observable<CrudCacheParameters>;
  @Input() searchOn = false;
  @Input() showToggleAll = false;
  @Input() overlayVisible = false;
  @Input() placeholder = '';
  @Output() EmployeeChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Input() enum = false;

  @ViewChild('input', { static: false }) input: MultiSelect;

  // realItems$: Observable<U[]>;

  // @ViewChild(MultiSelect) input: MultiSelect;

  defaultIcon = DefaultIcon;

  private get control() {
    const controlName = this.fieldName?.toString();
    return controlName ? this.form?.controls?.[controlName] : undefined;
  }

  override ngOnInit(): void {
    if (this.enum) this.displayProperty = 'value';
    super.ngOnInit();
  }
  //   // this.realItems$ = this.items$;
  //   if (this.unfilteredItems$) {
  //     this.realItems$ = this.items$.pipe(
  //       map((items) => {
  //         // console.log('items', items);
  //         const uniqueHubs = items.map((hub) => {
  //           return { item: hub };
  //         });
  //         // .filter((item, index, array) => array.findIndex((x) => x.hubId == item.hubId) == index)
  //         // .sort((a, b) => a.hubId - b.hubId);

  //         const newItems = uniqueHubs.map((hub) => {
  //           return {
  //             id: hub.item.id,
  //             name: hub.item['name'],
  //             items: hub.item['items']
  //           };
  //         });
  //         console.log('filtered', newItems);
  //         return newItems as unknown as U[];
  //       })
  //     );
  //   } else {
  //     this.realItems$ = this.items$;
  //   }
  // }

  selectGroup(items: U[]) {
    const newIds = (items.map((item) => item[this.keyProperty]) as []) ?? [];
    const currentIds = (this.form.get(this.fieldName ?? '')?.value as []) ?? [];
    const allPriorSelected = newIds.every((id) => currentIds.includes(id));
    if (allPriorSelected) {
      const totalIds = currentIds.filter((value) => !newIds.includes(value));
      this.form.controls[this.fieldName ?? '']?.setValue(totalIds as string[]);
    } else {
      const totalIds = [...newIds, ...currentIds].filter((value, index, self) => self.indexOf(value) === index);
      this.form.controls[this.fieldName ?? '']?.setValue(totalIds as string[]);
    }
  }

  getSelectedValues(): string[] {
    // console.log('test', this.items$, this.unfilteredItems$);
    return this.form.controls[this.fieldName ?? '']?.value;
  }

  // updateModel() {
  //   // console.log('updateModel', this.form.controls[this.fieldName?.toString()].value);
  //   this.EmployeeChange.emit(this.form.controls[this.fieldName?.toString()].value);
  //   // this.input.getOptionValue;
  // }

  onChange($event) {
    const selectedEmployeeIds: string[] = $event.value;
    //console.log('onChange', selectedEmployeeIds);
    this.EmployeeChange.emit(selectedEmployeeIds);
  }
}
